import { createTheme, Theme } from '@mui/material';
import { colors } from './colors';
import { iconButtonStyles } from './components/iconButtonStyles';
import { dividerStyles } from './components/dividerStyles';
import { buttonStyles } from './components/buttonStyles';
import { inputBaseStyles } from './components/inputBaseStyles';
import { textFieldStyles } from './components/textFieldStyles';
import { cardStyles } from './components/cardStyles';
import { radioStyles } from './components/radioStyles';
import { bottomNavigationActionStyles } from './components/bottomNavigationAction';
import { drawerStyles } from './components/drawerStyles';
import { menuStyles } from './components/menuStyles';
import { menuItemStyles } from './components/menuItemStyles';
import { chipStyles } from './components/chipStyles';

export function createComponents(theme: Theme) {
  return createTheme(theme, {
    components: {
      ...iconButtonStyles(theme),
      ...dividerStyles(theme),
      ...buttonStyles(theme),
      ...inputBaseStyles(theme),
      ...textFieldStyles(theme),
      ...cardStyles(theme),
      ...radioStyles(theme),
      ...bottomNavigationActionStyles(theme),
      ...drawerStyles(theme),
      ...menuStyles(theme),
      ...menuItemStyles(theme),
      ...chipStyles(theme),

      // OLD STYLES
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            color: `${colors.white}`,

            // transition: 'all .2s ease-in-out',
            // '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            //   background: 'transparent',
            //   width: '0.5rem',
            //   height: '0.5rem',
            // },
            // '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            //   background: theme.palette.primary.light,
            // },
            // '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover':
            //   {
            //     backgroundColor: theme.palette.primary.light,
            //   },
            // '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            //   backgroundColor: theme.palette.primary.light,
            // },
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            width: 'fit-content',
            textDecoration: 'none',
            color: `${theme.palette.secondary.dark}`,
            '&:hover': {
              textDecorationLine: 'underline',
              cursor: 'pointer',
              transition: 'all .2s ease-in-out',
            },
          },
        },
      },

      //   MuiDialogActions: {
      //     styleOverrides: {
      //       root: {
      //         padding: baseTheme.spacing(3),
      //       },
      //     },
      //   },
      MuiInputLabel: {
        // LABEL ///
        styleOverrides: {
          root: {
            textTransform: 'capitalize',
            // color: `${colors.lightSteelBlue}`,
            '&.Mui-focused': {
              //   color: `${common.purple}`,
            },
          },
          outlined: {
            borderRadius: 4,
            border: 'none',
            // padding: "14px",
            '&.Mui-focused': {
              backgroundColor: 'tranparent',
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '32px',
            fontFeatureSettings: "'clig' off, 'liga' off",
            // color: `${colors.darkGray}`,
          },
        },
      },

      MuiFormHelperText: {
        styleOverrides: {
          root: {
            // color: `${colors.utilityRed}`,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.104px',
            fontWeight: 600,
          },
        },
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            '&.Mui-focused': {},
          },
        },
      },
      MuiOutlinedInput: {
        //text on border
        styleOverrides: {
          root: {
            boxSizing: 'border-box',
            // color: `${colors.paleBlack}`,
            // backgroundColor: `${colors.maastrichtBlue}`,
            '&:hover': {
              '.MuiOutlinedInput-notchedOutline': {
                // borderColor: `${colors.shadowBlue}`,
              },
            },
            '&.Mui-focused': {
              '.MuiOutlinedInput-notchedOutline': {
                // border: `.6px solid ${colors.purple} !important`,
              },
            },
          },
          notchedOutline: {
            transition: 'all .2s ease-in-out',
            // border: `.6px solid ${colors.charcoal}`, //fieldset border
            '&:hover': {
              //   border: `.6px solid ${colors.shadowBlue}`,
            },
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          root: {},
          thumb: {
            // backgroundColor: `${colors.mediumNavy}`,
          },
          track: {
            // backgroundColor: `${colors.gray}`,
          },
        },
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });
}
